import { toast } from 'react-toastify';

const ToastUtils = {
  success: (message, options = {}) => {
    toast.success(message, {
      ...options,
    });
  },
  
  error: (message, options = {}) => {
    toast.error(message, {
      ...options,
    });
  },
  
  warning: (message, options = {}) => {
    toast.warning(message, {
      ...options,
    });
  },
  
  info: (message, options = {}) => {
    toast.info(message, {
      ...options,
    });
  },
  
  // Метод для показа кастомного уведомления
  show: (message, options = {}) => {
    toast(message, {
      ...options,
    });
  },
  
  // Метод для закрытия всех уведомлений
  closeAll: () => {
    toast.dismiss();
  }
};

export default ToastUtils;